<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import AppHamburgerMenu from './AppHamburgerMenu.vue'

const page = usePage()

const items = computed(() => page.props.menu ?? [])

const uncollapsedItems = computed(() => {
    const arr = [...items.value]
    const idx = arr.findIndex(i => i.selected)
    if (idx > 1) {
        const sel = arr.splice(idx, 1)[0]
        arr.splice(1, 0, sel)
    }
    return arr.slice(0, 2)
})
</script>

<template>
    <div class="fixed bottom-0 flex items-center z-20 w-full">
        <div class="bg-white/80 dark:bg-black/20 dark:border-0 border-t backdrop-blur-lg shadow-lg items-center gap-4 w-full px-4 flex">
            <AppHamburgerMenu/>

            <Link v-for="uncollapsed in uncollapsedItems" :key="uncollapsed.label" :href="uncollapsed.route" prefetch
                  :class="uncollapsed.selected ? (uncollapsed.needsUpgrade ? 'bg-yellow-50 dark:bg-yellow-950 !text-yellow-800 border-b-2 dark:!text-yellow-300 dark:!border-yellow-300 border-yellow-500' : 'bg-blue-50 dark:bg-blue-950 !text-blue-800 border-b-2 dark:!text-blue-300 dark:!border-blue-300 border-blue-500' ) : 'border-b-2 border-transparent'"
                  class="flex flex-col relative items-center text-neutral-700 dark:text-neutral-200 justify-center hover:text-blue-600 w-18 pb-0.5 px-2 my-1 rounded-lg transition text-sm">
                <i :class="[uncollapsed.icon]" class="!text-lg w-10 h-8 flex items-center justify-center rounded-lg"/>
                <p class="text-xs opacity-80">{{ uncollapsed.label }}</p>
                <div v-if="uncollapsed.needsUpgrade" class="absolute -top-1 -right-1 text-black bg-yellow-500 rounded-full w-5 flex justify-center items-center h-5 p-1">
                    <i class="pi pi-crown !text-xs"/>
                </div>
            </Link>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
